module.exports = __webpack_public_path__ + "static/img/btn3-checked.caa49c6a.png";